import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { ContactoService } from '../../../../providers/contacto.service';
import { Telefono, telefonoValidator } from '../../../../components/telefono/telefono.component';
import { Entidad } from '../../../../interfaces/entidad';
import { Examen } from '../../../../interfaces/examen';
import { KitBienvenida } from '../../../../interfaces/kit-bienvenida';
import { PerfilWeb } from '../../../../interfaces/perfil-web';
import { TipoPago } from '../../../../interfaces/tipo-pago';
import { EntidadService } from '../../../../providers/entidad.service';
import { TipoPagoService } from '../../../../providers/tipo-pago.service';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {
  @Input() contactoData: Contacto = null;

  contacto: Contacto;
  tiposContacto: TipoContacto[] = [];
  cargandoTiposContacto: boolean = false;
  @Output() onContactoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  @Input() razonSocial: string; // traigo la razon social de la entidad.
  tipoContactoFormControl = new FormControl('', [
    Validators.required
  ]);
  nombreFormControl = new FormControl('', [
    Validators.required
  ]);
  apellidoFormControl = new FormControl();
  razonSocialFormControl = new FormControl();
  cargoFormControl = new FormControl();
  emailFormControl = new FormControl('', [Validators.email]);
  celularCodigoPaisFormControl = new FormControl();
  celularCodigoAreaFormControl = new FormControl();
  celularNumeroFormControl = new FormControl();
  telefonoCodigoPaisFormControl = new FormControl();
  telefonoCodigoAreaFormControl = new FormControl();
  telefonoNumeroFormControl = new FormControl();
  internoFormControl = new FormControl();
  fechaAltaFormControl = new FormControl();
  dia_nacimientoFormControl = new FormControl();
  mes_nacimientoFormControl = new FormControl();
  fechaModificacionFormControl = new FormControl();
  usuarioModificacionFormControl = new FormControl();
  fechaCertificacionFormControl = new FormControl();
  fechaUltimaCertificacionFormControl = new FormControl();
  examenesFormControl = new FormControl();
  kitsFormControl = new FormControl();
  perfilesFormControl = new FormControl();
  pagosFormControl = new FormControl();
  entidadFormControl = new FormControl('', [
    Validators.required
  ]);
  examenes: Examen[] = [];
  kits: KitBienvenida[] = [];
  perfiles: PerfilWeb[] = [];
  pagos: TipoPago[] = [];
  numberOfDays: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: string[] = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  constructor(
    private contactoService: ContactoService,
    private entidadService: EntidadService,
    private pagoService: TipoPagoService
  ) { }


  ngOnInit(): void {
    if (this.contactoData) {
      // console.log('contactoData', this.contactoData);
      this.contacto = new Contacto(
        this.contactoData.apellido,
        this.contactoData.cargo,
        this.contactoData.celularCodigoPais,
        this.contactoData.celularCodigoArea,
        this.contactoData.celularNumero,
        this.contactoData.email,
        <Entidad>{
          IdEntidad: this.contactoData.entidad.IdEntidad,
          razonSocial: this.contactoData.entidad.razonSocial
        },
        this.contactoData.examen,
        this.contactoData.fechaAlta,
        this.contactoData.fechaCertificacion,
        this.contactoData.fechaModificacion,
        this.contactoData.usuarioModificacion,
        this.contactoData.dia_nacimiento,
        this.contactoData.mes_nacimiento,
        this.contactoData.fechaUltimaCertificacion,
        this.contactoData.idContacto,
        this.contactoData.interno,
        this.contactoData.kit,
        this.contactoData.nombre,
        this.contactoData.pago,
        this.contactoData.perfil,
        this.contactoData.razonSocial,
        this.contactoData.telefonoCodigoPais,
        this.contactoData.telefonoCodigoArea,
        this.contactoData.telefonoNumero,
        <TipoContacto>{
          IdTipoContacto: this.contactoData.tipoContacto.IdTipoContacto,
          tipoContactoDesc: this.contactoData.tipoContacto.tipoContactoDesc
        },
      )
      this.telefonoCodigoPaisFormControl.setValue(this.contacto.telefonoCodigoPais);
      this.telefonoCodigoAreaFormControl.setValue(this.contacto.telefonoCodigoArea);
      this.telefonoNumeroFormControl.setValue(this.contacto.telefonoNumero);
      this.celularCodigoPaisFormControl.setValue(this.contacto.celularCodigoPais);
      this.celularCodigoAreaFormControl.setValue(this.contacto.celularCodigoArea);
      this.celularNumeroFormControl.setValue(this.contacto.celularNumero);
      // console.log('contactoData 2', this.contactoData);
    } else {
      this.contacto = new Contacto();
      this.contacto.razonSocial = this.razonSocial;
    }
    this.tiposContacto = [];
    this.cargandoTiposContacto = true;
    this.contactoService.getTiposContacto().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          if (respuesta.data.tiposContacto) {
            respuesta.data.tiposContacto.forEach(tipoContacto => {
              this.tiposContacto.push(<TipoContacto>{
                IdTipoContacto: tipoContacto.IdTipoContacto,
                tipoContactoDesc: tipoContacto.TipoContactoDesc
              });
            });
          }
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'El contacto no podrá ser asignado'
          });
        }
        // console.log('Entro 1');
        this.cargandoTiposContacto = false;
      },
      error => {
        // console.log('Entro 2');
        this.cargandoTiposContacto = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );

    this.entidadService.getExamen().subscribe(
      respuesta => {
        // console.log('Examen', respuesta);
        this.examenes = respuesta.data.examenes;
      },
    );
    this.entidadService.getKitBienvenida().subscribe(
      respuesta => {
        // console.log('Kit Bienvenida', respuesta);
        this.kits = respuesta.data.kits;
      },
    )
    this.entidadService.getPerfilWeb().subscribe(
      respuesta => {
        // console.log('Perfil Web', respuesta);
        this.perfiles = respuesta.data.perfiles;
      },
    )
    this.traerPagos();
  }


  traerPagos(): void {
    this.pagos = [];
    this.pagoService.getTiposPago(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.pagos) {
          respuesta.data.pagos.forEach((pago) => {
            this.pagos.push(<TipoPago>{
              id: pago.id,
              descripcion: pago.descripcion
            });
          });
          // console.log('Tipos de Pago', this.pagos);

        }
      },
      () => {
      }
    );
  }


  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onContactoInput.emit();
  }

  compararTipoContacto(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdTipoContacto == tipo2.IdTipoContacto;
    }

    return false;
  }



  getContacto(): Contacto {
    if (this.nombreFormControl.hasError('required') ||
      this.tipoContactoFormControl.hasError('required') ||
      this.emailFormControl.hasError('required') ||
      this.emailFormControl.hasError('email') ||
      (this.telefonoCodigoPaisFormControl.hasError('required') && this.telefonoCodigoAreaFormControl.hasError('required') && this.telefonoNumeroFormControl.hasError('required') && this.celularCodigoPaisFormControl.hasError('required') && this.celularCodigoAreaFormControl.hasError('required') && this.celularNumeroFormControl.hasError('required'))
    ) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.nombreFormControl.markAsTouched();
      this.tipoContactoFormControl.markAsTouched();
      this.emailFormControl.markAsTouched();
      this.telefonoCodigoPaisFormControl.markAsTouched();
      this.telefonoCodigoAreaFormControl.markAsTouched();
      this.telefonoNumeroFormControl.markAsTouched();
      this.celularCodigoPaisFormControl.markAsTouched();
      this.celularCodigoAreaFormControl.markAsTouched();
      this.celularNumeroFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    if (this.tipoContactoFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.tipoContactoFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    console.log(this.contacto,'aca');
    
    return this.contacto;
  }

  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }

}
